// extracted by mini-css-extract-plugin
export default {"dev_env_title":"MultiLangEvnSetup-module_dev_env_title__XAdIv","tabs":"MultiLangEvnSetup-module_tabs__WPXNG","tab_panel":"MultiLangEvnSetup-module_tab_panel__WPLLN"};